$(() => {
  $('.nav__toggle').click(() => {
    $('.nav').toggleClass('open');
  });
  $('.nav__dropdown').click(() => {
    $('.nav').toggleClass('open');
  });
});
